<div class="h-full bg-brand-cam flex flex-col text-white shadow-md"
  [ngClass]="isMobile ? 'w-32' : 'w-64'"
>
  <!-- Encabezado con Logo o Título -->
  <div class="p-4 flex items-center justify-center border-b border-gray-700 cursor-pointer" [routerLink]="'/admin/home'">
    <ng-container  *ngIf="!isMobile">
  <span class="font-bold tracking-wider uppercase text-center">LA SOBERANÍA DE SEGUROS</span>
    </ng-container>
    <ng-container  *ngIf="isMobile">
  <img src="assets/imgs/logo-la-soberania-2.png" alt="Logo" class="h-8" />
    </ng-container>

  </div>

  <!-- Contenido scrollable -->
  <div class="flex-1 overflow-y-auto flex flex-col text-sm">
    <!-- Enlaces -->
    <a [routerLink]="'/' + idTienda + '/dashboard'" (click)="isMobile ? ocultarSidenav() : null" routerLinkActive="bg-white text-brand-primary font-bold shadow-md"
      [ngClass]="{ 'hover:bg-white/10': !rlaDashboard?.isActive }" class="flex items-center px-4 py-3"
      #rlaDashboard="routerLinkActive" *ngIf="idRolUsuario != 3">
      <span class="material-icons mr-4" routerLinkActive="text-brand-primary">donut_small</span>
      <span class="text-sm font-medium">Inicio</span>
    </a>

    <a [routerLink]="'/' + idTienda + '/contactos'" (click)="isMobile ? ocultarSidenav() : null" routerLinkActive="bg-white text-brand-primary font-bold shadow-md"
      [ngClass]="{ 'hover:bg-white/10': !rlaContactos?.isActive }" class="flex items-center px-4 py-3"
      #rlaContactos="routerLinkActive" *ngIf="idRolUsuario != 3">
      <span class="material-icons mr-4" routerLinkActive="text-brand-primary">contacts</span>
  <span class="text-sm font-medium">Clientes</span>
    </a>

    <a [routerLink]="'/' + idTienda + '/usuarios'" (click)="isMobile ? ocultarSidenav() : null" routerLinkActive="bg-white text-brand-primary font-bold shadow-md"
      [ngClass]="{ 'hover:bg-white/10': !rlaUsuarios?.isActive }" class="flex items-center px-4 py-3"
      #rlaUsuarios="routerLinkActive" *ngIf="idRolUsuario != 3">
      <span class="material-icons mr-4" routerLinkActive="text-brand-primary">group</span>
      <span class="text-sm font-medium">Usuarios</span>
    </a>

    <a [routerLink]="'/' + idTienda + '/vehiculos'" (click)="isMobile ? ocultarSidenav() : null" routerLinkActive="bg-white text-brand-primary font-bold shadow-md"
      [ngClass]="{ 'hover:bg-white/10': !rlaVehiculos?.isActive }" class="flex items-center px-4 py-3"
      #rlaVehiculos="routerLinkActive" *ngIf="idRolUsuario != 3">
      <span class="material-icons mr-4" routerLinkActive="text-brand-primary">settings</span>
      <span class="text-sm font-medium">Vehículos</span>
    </a>

    <a [routerLink]="'/' + idTienda + '/seguros'" (click)="isMobile ? ocultarSidenav() : null" routerLinkActive="bg-white text-brand-primary font-bold shadow-md"
      [ngClass]="{ 'hover:bg-white/10': !rlaContratos?.isActive }" class="flex items-center px-4 py-3"
      #rlaContratos="routerLinkActive">
      <span class="material-icons mr-4" routerLinkActive="text-brand-primary">payment</span>
      <span class="text-sm font-medium">Seguros</span>
    </a>

    <a [routerLink]="'/' + idTienda + '/siniestros'" (click)="isMobile ? ocultarSidenav() : null" routerLinkActive="bg-white text-brand-primary font-bold shadow-md"
      [ngClass]="{ 'hover:bg-white/10': !rlaSiniestros?.isActive }" class="flex items-center px-4 py-3"
      #rlaSiniestros="routerLinkActive" *ngIf="idRolUsuario != 3">
      <span class="material-icons mr-4" routerLinkActive="text-brand-primary">report_problem</span>
      <span class="text-sm font-medium">Siniestros</span>
    </a>

    <a [routerLink]="'/' + idTienda + '/cierres'" (click)="isMobile ? ocultarSidenav() : null" routerLinkActive="bg-white text-brand-primary font-bold shadow-md"
      [ngClass]="{ 'hover:bg-white/10': !rlaCierres?.isActive }" class="flex items-center px-4 py-3"
      #rlaCierres="routerLinkActive" *ngIf="idRolUsuario == 1 || idRolUsuario == 2">
      <span class="material-icons mr-4" routerLinkActive="text-brand-primary">payments</span>
      <span class="text-sm font-medium">Cierres</span>
    </a>

    <!-- Footer solo visible dentro del scroll en mobile -->
  </div>

  <!-- Footer clásico en desktop con trigger para cdkMenu -->
  <ng-container>
    <div class="p-1">
      <div class="h-[55px] p-[8px] flex justify-between select-none cursor-pointer" 
      #executable
        [cdkMenuTriggerFor]="optionsSidenav"
        (click)="isMobile ? ocultarSidenav() : null"
        >
        <div class="flex gap-2">
          <div class="bg-[#0b2034] w-[40px] h-full rounded-[3px] flex justify-center items-center text-white font-bold text-[20px]">
            <span>T</span>
          </div>
          <div class="flex flex-col text-[14px]" *ngIf="!isMobile">
            <span class="text-[#cdcdcd]">{{ nombreTienda | titlecase }}</span>
            <span class="text-xs text-white !font-normal max-w-[168px] whitespace-nowrap text-ellipsis overflow-hidden">
              Socio Comercial
            </span>
          </div>
        </div>
        <div class="flex items-center opacity-60">
          <img src="assets/svg/flecha-derecha.svg" class="h-5 w-5" />
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- Menú flotante (solo en desktop) -->
<ng-template #optionsSidenav>
  <div class="botonApariencia bg-white !text-[#344563] text-sm absolute bottom-0  shadow-lg w-72 rounded-lg z-50"
    [ngClass]="isMobile ? '' : 'left-[15.8rem]'"
    cdkMenu>
    <div class="flex flex-col" cdkMenuGroup>
      <div class="flex flex-col gap-[7.5px] px-3 py-2.5">
        <div class="flex justify-between">
          <span class="font">Usuario</span>
          <span class="text-[#C0C0C0]">{{ descNombreRol }}</span>
        </div>

        <div class="flex gap-2 items-center">
          <div class="bg-[#25176A] w-10 h-10 rounded-full text-white font-bold text-lg flex items-center justify-center">
            {{ nombreResponsable.substring(0, 1) | uppercase }}
          </div>
          <div class="flex flex-col min-w-[190px]">
            <span>{{ nombreResponsable }}</span>
            <span class="text-xs opacity-50">{{ email }}</span>
          </div>
          <img class="h-4 cursor-pointer" src="assets/svg/editar-usuario-sidenav.svg"
            [routerLink]="'/account/profile/my-account/'" />
        </div>
      </div>

      <div class="flex flex-col gap-[7.5px] px-3 py-2.5 border-y border-[#D4D4D4]">
        <span>Tienda</span>
        <div class="bg-[#F5F8FA] py-2 px-2.5 rounded text-sm">
          <span>{{ nombreTienda }}</span>
          <span class="text-[#64748B] text-xs">{{ direccionTienda }}</span>
        </div>
      </div>

      <div class="flex flex-col gap-2.5 px-3 py-2.5 border-t border-[#D4D4D4]">
        <div class="flex items-center gap-2.5 cursor-pointer" [routerLink]="'/app/admin'">
          <img src="assets/svg/back-sidenav.svg" class="h-6" />
          <span>Volver a mis tiendas</span>
        </div>
        <div class="flex items-center gap-2.5 cursor-pointer" (click)="onLogout()">
          <img src="assets/svg/logout-sidenav.svg" class="h-6" />
          <span>Cerrar la sesión</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>
